module.exports = __webpack_public_path__ + "static/media/ONAMA01.d1342caf.jpg";